module.exports = __webpack_public_path__ + "static/media/University_of_Roehampton.22a3a1b5.webp";